import { render } from "./Cell.vue?vue&type=template&id=6853cd52&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"

import "./Cell.vue?vue&type=style&index=0&id=6853cd52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6853cd52"

export default script